import { Typography } from 'antd'
import FindForestUseDeclaration from '../MapMenu/FindForestUseDeclaration'
import TabPane from './TabPane'
import {
    ToolOutlined
} from '@ant-design/icons';
import FindForestMaskPiece from '../MapMenu/FindForestMaskPiece';
import { useTranslation } from 'react-i18next';

interface IProps {
    number: number,
    showFindForestMask?: boolean;
}

export const ToolsTabIcon = ToolOutlined;

export default function ToolsTab(props: IProps) {
    const { t } = useTranslation("sidePanelTabs");

    return (
        <TabPane number={props.number}>
            <>
                <Typography.Title level={4}>{t("apuvälineitäOtsikko")}</Typography.Title>
                <FindForestUseDeclaration />
                {props.showFindForestMask === true && <FindForestMaskPiece />}
            </>
        </TabPane>
    )
}